exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-tip[data-v-b9de110a]{text-align:center}", ""]);

// exports
